
import MeetingUser from "./meeting-user";
import Collection from "../../../data-structures/collection";
import {MeetingRole} from "../const";
import {SortDirection} from "../../../data-structures/sort";

const debug = false
// const debug = "EventBaseModel"




export default class MeetingUsers extends Collection<MeetingUser> {

    static initFromJson(data:any):MeetingUsers {
        const meetingUsers = new MeetingUsers()

        _.map(data, (record)=>{
            meetingUsers.add(new MeetingUser(record))
        })

        return meetingUsers
    }


    isOrganizer(userId:ID):boolean {
        return this.get(userId)?.role === MeetingRole.ORGANIZER
    }

    get userIds() {
        return _.map(this.models, meetingUser=>{
            return meetingUser.userId
        })
    }

    userIdsSortedByRole():ID[] {

        const usersSortedByRole:MeetingUser[] = _.orderBy(this.models, meetingUser=>{
            return meetingUser.role
        }, [SortDirection.ASC])

        // const firstXUsers = usersSortedByRole.slice(0, howMany)

        return _.map(usersSortedByRole, meetingUser=>{return meetingUser.userId })


    }


}



